// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__olWNg","footer":"Form_footer__2P72J"};